import * as React from "react"
const HistoryIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 40 }
        height={ 40 }
        fill="none"
        { ...props }
    >
        <g clipPath="url(#a)">
            <path
                fill="#265C76"
                d="M27.531 18.828h-4.476v-5.732a1.172 1.172 0 0 0-2.344 0V20c0 .647.525 1.172 1.172 1.172h5.648a1.172 1.172 0 0 0 0-2.344Z"
            />
            <path
                fill="#F2C72F"
                d="M34.694 7.19a17.999 17.999 0 0 0-12.811-5.307c-4.84 0-9.389 1.884-12.81 5.306a17.983 17.983 0 0 0-5.27 11.64H1.172a1.172 1.172 0 0 0-.829 2l6.276 6.276a1.172 1.172 0 0 0 1.657 0l6.277-6.276a1.172 1.172 0 0 0-.83-2h-2.53c.586-5.38 5.157-9.582 10.69-9.582 2.872 0 5.572 1.119 7.603 3.15A10.682 10.682 0 0 1 32.636 20c0 5.929-4.824 10.753-10.753 10.753a10.745 10.745 0 0 1-5.377-1.44 3.684 3.684 0 0 0-1.838-.495 3.695 3.695 0 0 0-3.192 1.842 3.658 3.658 0 0 0-.368 2.794c.247.92.827 1.695 1.637 2.19a18.111 18.111 0 0 0 9.137 2.474c4.84 0 9.39-1.885 12.812-5.307A17.998 17.998 0 0 0 40 20c0-4.84-1.885-9.389-5.306-12.81Z"
            />
            <path
                fill="#1D4659"
                d="M27.531 18.828h-4.476v-5.732c0-.647-.525-1.171-1.172-1.171v9.247h5.648a1.172 1.172 0 0 0 0-2.344Z"
            />
            <path
                fill="#FB9E14"
                d="M34.694 7.19a17.999 17.999 0 0 0-12.811-5.307v7.365c2.872 0 5.572 1.118 7.603 3.149A10.682 10.682 0 0 1 32.636 20c0 5.93-4.824 10.753-10.753 10.753v7.364c4.84 0 9.389-1.884 12.81-5.306A17.999 17.999 0 0 0 40 20c0-4.84-1.885-9.389-5.306-12.81Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </svg>
)
export default HistoryIcon
